import { Injectable } from '@angular/core';
import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

// Corrige la asignación de vfs
(pdfMake as any).vfs = (pdfFonts as any).pdfMake.vfs;

@Injectable()
export class PDF {

  public async exportAsPDFFile( docDefinition: { content: any[] }, PDFFileName: string ) {
    await pdfMake.createPdf( docDefinition ).download( PDFFileName );
    /* var win = window.open('', '_blank');
    await pdfMake.createPdf( docDefinition ).open({}, win); */
  }

  public async exportAsPDFFile2( docDefinition: { content: any[] }, PDFFileName: string ) {
    await pdfMake.createPdf( docDefinition ).open();
  }
}